import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SimpleMenu } from '@/components/MenuGrid';
import { useLocale } from '@/context/LocaleContext';
import { api } from '@/lib/axios';

export function DonationHeader() {
  const { t, locale } = useLocale();
  const { data, isError, refetch } = useQuery({
    queryKey: ['donations', 'limit'],
    queryFn: async () => {
      const { data } = await api.get<{ data: { remaining: number; max_limit: number; reset_at: string | null; server_now: string } }>('/api/v1/donations/limit');
      return { ...data.data, receivedAt: performance.now() };
    },
    refetchInterval: 30000,
    staleTime: 0,
  });
  const [now, setNow] = useState(performance.now());
  useEffect(() => {
    if (!data?.reset_at) return;
    const timer = window.setInterval(() => setNow(performance.now()), 1000);
    return () => window.clearInterval(timer);
  }, [data?.reset_at]);
  const seconds = data?.reset_at ? Math.max(0, Math.ceil((Date.parse(data.reset_at) - Date.parse(data.server_now) - Math.max(0, now - data.receivedAt)) / 1000)) : null;
  useEffect(() => {
    if (seconds === 0) void refetch();
  }, [seconds, refetch]);
  const time = seconds == null ? '' : [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
  return <SimpleMenu title={t('donation')}>
    <div className="donation-reset">
      {data ? <>
        <span>{t('don_limit_available', { amount: new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }).format(data.remaining) })}</span>
        <strong>{seconds === null ? t('don_reset_ready') : seconds === 0 ? t('don_reset_updating') : t('don_reset_in', { time })}</strong>
      </> : <span>{t(isError ? 'don_reset_error' : 'don_history_loading')}</span>}
    </div>
  </SimpleMenu>;
}
